import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {ElementRef} from "@angular/core";

export function fileSizeValidator(elementRef: ElementRef<HTMLInputElement>, maxFileSizeInBytes: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!elementRef?.nativeElement?.files) {
      return null;
    }

    const file = elementRef.nativeElement.files[0];
    if (file) {
      const fileSize = file.size;
      if (fileSize > maxFileSizeInBytes) {
        return {fileSize: true};
      }
    }
    return null;
  };
}
